export const labsStatusEnum = {
  Active: true,
  Inactive: false,
  getKeyByValue(value) {
    return Object.keys(this).find(key => this[key] === value);
  },
};

export const labsStatusColorEnum = colors => ({
  [labsStatusEnum.Active]: {
    color: colors.white,
    backgroundColor: colors.greenMain,
  },
  [labsStatusEnum.Inactive]: {
    color: colors.black,
    backgroundColor: colors.grey004,
  },
});

const activeStatusList = [
  { key: 0, name: 'Active', value: true },
  { key: 1, name: 'Inactive', value: false },
];

export const filters = {
  dropDownFilters: [
    {
      filterKey: 1,
      filterLabel: 'Status',
      filterDataValue: activeStatusList,
      filterObjMapper: { key: 'value', name: 'name' },
      filterSearchKey: 'isActive',
      filterSearchBarPlaceholder: 'Search by Status',
      filterType: 'single',
    },
  ],
};

export const addLabFormValidationErrorType = {
  valid: 1,
  empty: 2,
  wrong: 3,
};
